/** AnimatedSprite2D registration: parser and formatter. */
import { nodeRegistry } from '../../../core/NodeRegistry';
import { parseAnimatedSprite2D } from './parser';
import { formatAnimatedSprite2DProperties } from './propertyFormatter';
const animatedSprite2DRegistration = {
    typeName: 'AnimatedSprite2D',
    parser: parseAnimatedSprite2D,
    propertyFormatter: formatAnimatedSprite2DProperties,
};
nodeRegistry.register(animatedSprite2DRegistration);
export * from './parser';
export * from './propertyFormatter';
export * from './types';
//# sourceMappingURL=index.js.map